import { DirectedComputationConditionGroup } from '../models/computations/Computation';
import { getVerbSettings, Verb } from '../models/sqlform';
import Computation from '../models/computations/Computation';

export function isStringVerb(verb: Verb) {
  return getVerbSettings(verb)?.characteristics.types.includes('string');
}

/**
 * Ensure all string-verb conditions have truthy "isLower" value if undefined.
 */
export function ensureLowerConditions(
  conditionGroups: DirectedComputationConditionGroup[]
) {
  return conditionGroups.map((group) => ({
    ...group,
    directedConditions: group.directedConditions.map((item) => ({
      ...item,
      condition: isStringVerb(item.condition.verb)
        ? {
            ...item.condition,
            isLower:
              typeof item.condition?.isLower === 'boolean'
                ? item.condition.isLower
                : true,
          }
        : item.condition,
    })),
  }));
}

/**
 * Determines if a computation is used in territory assignments.
 * This checks the actual usage data from teams rather than relying on naming patterns.
 */
export function isUsedInTerritory(computation: Computation): boolean {
  return computation.usedInTerritory || false;
}

/**
 * Whether a computation may be deployed on its own (RGI-2080).
 *
 * Only pending drafts qualify: a standard computation is not deployable at all,
 * and a renamed one would leave its old name behind in argo, so the endpoint
 * refuses it and the checkbox is not offered.
 *
 * ALWAYS returns a real boolean. A computation loaded from argo has no `isDraft`
 * field, so a bare `computation.isDraft &&` yields undefined - and this feeds a
 * table cell renderer, where returning undefined is React error #152 and takes
 * the whole page down.
 */
export function isComputationDeployable(computation: Computation): boolean {
  const { context, isDraft, name, oldName } = computation;

  return (
    Boolean(isDraft) &&
    context !== 'standard' &&
    !(oldName && oldName !== name)
  );
}
